export default __webpack_public_path__ + "static/94-1724e7e06a1a2dce58e7c4ba7bafd3cf.gif";